__turbopack_context__.v({
  "arrow": "TaxUnitSelector-module-scss-module__PgDuaa__arrow",
  "button": "TaxUnitSelector-module-scss-module__PgDuaa__button",
  "container": "TaxUnitSelector-module-scss-module__PgDuaa__container",
  "inner": "TaxUnitSelector-module-scss-module__PgDuaa__inner",
  "left": "TaxUnitSelector-module-scss-module__PgDuaa__left",
  "menu": "TaxUnitSelector-module-scss-module__PgDuaa__menu",
  "menuItem": "TaxUnitSelector-module-scss-module__PgDuaa__menuItem",
  "name": "TaxUnitSelector-module-scss-module__PgDuaa__name",
  "right": "TaxUnitSelector-module-scss-module__PgDuaa__right",
  "ssn": "TaxUnitSelector-module-scss-module__PgDuaa__ssn",
});
